import { useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";
import { errMsg } from "@/lib/api";
import { resizeImage } from "@/lib/branding";
import { usePanel } from "@/pages/staff/PanelLayout";

export function MenuImageField({ value, onChange, inputCls, onBusy }) {
  const { req } = usePanel();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true); onBusy(true);
    try {
      const data = await resizeImage(file, 600, "image/jpeg", true, 0.75);
      onChange((await req("post", "/staff/media", { data })).url);
      toast.success("Gambar dimuat naik");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); onBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="menu-image-field">
      <div className="flex items-center gap-3">
        <div className="relative w-20 h-20 rounded-xl border bg-amber-50 overflow-hidden shrink-0">
          {value ? <img src={value} alt="" className="w-full h-full object-cover" data-testid="menu-form-image-preview" />
            : <img src="/img/logo.png" alt="" className="w-full h-full object-contain p-2 opacity-60" />}
          {busy && <div className="absolute inset-0 bg-white/70 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-[#B91C1C]" /></div>}
        </div>
        <div className="flex flex-col gap-2">
          <label className={`px-4 h-10 rounded-lg bg-[#B91C1C] text-white text-sm font-semibold flex items-center gap-2 cursor-pointer active:scale-95 transition-transform ${busy ? "opacity-60 pointer-events-none" : ""}`}>
            <Upload className="w-4 h-4" />{value ? "Tukar Gambar" : "Muat Naik Gambar"}
            <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid="menu-form-image-upload" />
          </label>
          {value && <button type="button" onClick={() => onChange("")} data-testid="menu-form-image-remove" className="text-xs text-red-600 flex items-center gap-1"><X className="w-3 h-3" />Buang gambar</button>}
        </div>
      </div>
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="atau tampal URL gambar" data-testid="menu-form-image" className={inputCls} />
    </div>
  );
}
